import { FaInstagram, FaXTwitter, FaLinkedinIn, FaYoutube } from "react-icons/fa6";
import React from "react";

const DISPLAY_FONT = "'Anton', 'Oswald', 'Arial Narrow', sans-serif";

const DEFAULT_SOCIALS = [
    { name: "Instagram", href: "https://instagram.com/imvijaysaran", Icon: FaInstagram },
    { name: "Twitter", href: "https://x.com/imvijaysaran", Icon: FaXTwitter },
    { name: "YouTube", href: "https://youtube.com/@ImVijaySaran", Icon: FaYoutube },
    { name: "LinkedIn", href: "https://linkedin.com/in/imvijaysaran", Icon: FaLinkedinIn },
  ];

const About = ({
  label = "About",
  title = "onpointcombat",
  description = "Vijay Saran is an entrepreneur, podcast host, and active MMA practitioner. He has built businesses in e-commerce, Web3, and decentralised finance, and hosts Built Different, featuring WBC champions, MMA fighters, and other combat sports personalities. He also trains alongside professional fighters, bringing firsthand familiarity with the sport to his work in combat sports media.",
  className = "",
  socials = DEFAULT_SOCIALS,
}) => {
  const headingId = `about-${title.toLowerCase().replace(/\s+/g, "-")}`;

  return (
    <section aria-labelledby={headingId} className={`border border-[#2A2A2A] border-l-4 border-l-[#D0182B] bg-[#141414] p-6 md:p-8 ${className}`}
    >
      <span
        style={{ fontFamily: DISPLAY_FONT }}
        className="mb-3 inline-block text-xs font-semibold uppercase tracking-[0.15em] text-[#D0182B]"
      >
        {label}
      </span>

      <h2
        id={headingId}
        style={{ fontFamily: DISPLAY_FONT }}
        className="mb-4 text-2xl uppercase leading-tight tracking-tight text-[#EDEAE1] md:text-3xl"
      >
        {title}
      </h2>

      <p className="max-w-3xl text-base leading-relaxed text-[#8C8880]">
        {description}
      </p>

      {socials.length > 0 && (
        <div className="mt-6 flex flex-wrap items-center gap-2 border-t border-[#2A2A2A] pt-5">

          {socials.map(({ name, href, Icon }) => (
            <a
              key={name}
              href={href}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={name}
              className="flex h-10 w-10 items-center justify-center border-2 border-[#2A2A2A] text-[#8C8880] transition-all hover:border-[#D0182B] hover:bg-[#D0182B] hover:text-[#EDEAE1] transitionAll"
            >
              <Icon className="h-4 w-4" />
            </a>
          ))}
        </div>
      )}
    </section>
  );
};

export default About;